import { render, staticRenderFns } from "./ActionEfficacy.vue?vue&type=template&id=52418484&scoped=true&"
import script from "./ActionEfficacy.vue?vue&type=script&lang=js&"
export * from "./ActionEfficacy.vue?vue&type=script&lang=js&"
import style0 from "./ActionEfficacy.vue?vue&type=style&index=0&id=52418484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52418484",
  null
  
)

export default component.exports